enum YouTubeKind {
  YouTubeVideos = 'youtube#video',
  YouTubePlaylist = 'youtube#playlist',
  YouTubeChannel = 'youtube#channel',
}

export default YouTubeKind;
